export default __webpack_public_path__ + "static/media/1982.08cd85dc.png";